const Speakers = (props) => {
  return (
    <section className="w-100 flex justify-center bg-[url(../../assets/images/speakers-bg.png)] bg-cover bg-top pt-16 pb-80">
      <div
        data-aos="fade-up"
        id={props.currentLang === "eng" ? "speakers" : "konusmacilar"}
        className="w-4/5 max-w-screen-xl space-y-16 pt-32"
      >
        <div className="flex justify-center">
          <h4 className="text-yellow-custom font-bold text-4xl sm:text-5xl md:text-7xl text-center">
            {props.currentLang === "eng" ? "SPEAKERS" : "KONUŞMACILAR"}
          </h4>
        </div>
        <div className="flex flex-col md:flex-row flex-wrap justify-around">
          <div className="flex flex-col items-center w-full md:w-1/2 lg:w-1/4 mb-5">
            <div className="w-56 h-56 lg:w-52 lg:h-52 2xl:w-60 2xl:h-60 bg-white rounded-full overflow-hidden text-green-custom flex justify-center items-center text-2xl font-medium">
              {props.currentLang === "eng" ? "PHOTO" : "FOTOĞRAF"}
            </div>
            <div className="flex flex-col justify-center ">
              <h5 className="text-yellow-custom font-bold text-2xl text-center">
                {props.currentLang === "eng" ? "Name" : "Ad"} <br />{" "}
                {props.currentLang === "eng" ? "Surname" : "Soyad"}
              </h5>
              <small className="text-white text-base font-medium text-center">
                {props.currentLang === "eng" ? "Title" : "Ünvan"}
              </small>
            </div>
          </div>
          <div className="flex flex-col items-center w-full md:w-1/2 lg:w-1/4 mb-5">
            <div className="w-56 h-56 lg:w-52 lg:h-52 2xl:w-60 2xl:h-60 bg-white rounded-full overflow-hidden text-green-custom flex justify-center items-center text-2xl font-medium">
              {props.currentLang === "eng" ? "PHOTO" : "FOTOĞRAF"}
            </div>
            <div className="flex flex-col justify-center ">
              <h5 className="text-yellow-custom font-bold text-2xl text-center">
                {props.currentLang === "eng" ? "Name" : "Ad"} <br />{" "}
                {props.currentLang === "eng" ? "Surname" : "Soyad"}
              </h5>
              <small className="text-white text-base font-medium text-center">
                {props.currentLang === "eng" ? "Title" : "Ünvan"}
              </small>
            </div>
          </div>
          <div className="flex flex-col items-center w-full md:w-1/2 lg:w-1/4 mb-5">
            <div className="w-56 h-56 lg:w-52 lg:h-52 2xl:w-60 2xl:h-60 bg-white rounded-full overflow-hidden text-green-custom flex justify-center items-center text-2xl font-medium">
              {props.currentLang === "eng" ? "PHOTO" : "FOTOĞRAF"}
            </div>
            <div className="flex flex-col justify-center ">
              <h5 className="text-yellow-custom font-bold text-2xl text-center">
                {props.currentLang === "eng" ? "Name" : "Ad"} <br />{" "}
                {props.currentLang === "eng" ? "Surname" : "Soyad"}
              </h5>
              <small className="text-white text-base font-medium text-center">
                {props.currentLang === "eng" ? "Title" : "Ünvan"}
              </small>
            </div>
          </div>
          <div className="flex flex-col items-center w-full md:w-1/2 lg:w-1/4 mb-5">
            <div className="w-56 h-56 lg:w-52 lg:h-52 2xl:w-60 2xl:h-60 bg-white rounded-full overflow-hidden text-green-custom flex justify-center items-center text-2xl font-medium">
              {props.currentLang === "eng" ? "PHOTO" : "FOTOĞRAF"}
            </div>
            <div className="flex flex-col justify-center ">
              <h5 className="text-yellow-custom font-bold text-2xl text-center">
                {props.currentLang === "eng" ? "Name" : "Ad"} <br />{" "}
                {props.currentLang === "eng" ? "Surname" : "Soyad"}
              </h5>
              <small className="text-white text-base font-medium text-center">
                {props.currentLang === "eng" ? "Title" : "Ünvan"}
              </small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Speakers;
